import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/SelfPickup/SelfPickup.jsx");
